import { API, authClient } from "../index";
import { uploadSingleFile } from "../files";

// Get all countries
export const getPartners = () => {
    return authClient().get(`${API}/partner/?getDisabled=true`);
};

// Get partner by id
export const getPartnerById = (id) => {
    return authClient().get(`${API}/partner/${id}`);
};

// Delete partner
export const deletePartner = (id) => {
    return authClient().delete(`${API}/partner/${id}`);
};

export const swapOrdersPartner = async (id1, id2) => {
    return authClient().post(`${API}/partner/swap-orders`, { id1, id2 });
};

// Create partner
export const postPartner = async (partner, logo) => {
    if (logo) {
        const response = await uploadSingleFile(logo, "logos");
        partner.logoURL = response?.data?.fileURL;
    }

    return authClient().post(`${API}/partner`, partner);
};

// Update partner
export const updatePartner = async (id, partner, logo) => {

    if (logo) {
        const response = await uploadSingleFile(logo, "logos");
        partner.logoURL = response?.data?.fileURL;
    }
    return authClient().put(`${API}/partner/${id}`, partner);
};
